import { createContext, useContext } from 'react';

export type CodeBlockContextType = {
  codeBlockIndices?: Record<string, number>;
};

export const CodeBlockContext = createContext<CodeBlockContextType>({});

export const useCodeBlockContext = () => useContext(CodeBlockContext);
